import { render, staticRenderFns } from "./ResultsListLetterItem.vue?vue&type=template&id=a5a25736"
import script from "./ResultsListLetterItem.vue?vue&type=script&lang=js"
export * from "./ResultsListLetterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports